import BaseModel from './BaseModel';

export default class ScreeningOutcomeSummary extends BaseModel {
  constructor(data = {}) {
    super(ScreeningOutcomeSummary, data);
    this.relevantCount = data.relevantCount;
    this.notRelevantCount = data.notRelevantCount;
    this.notSureCount = data.notSureCount;
  }

  totalOutcomes() {
    return (
      this.relevantCount +
      this.notRelevantCount +
      (this.notSureCount ?? 0)
    );
  }
}
